import React, { useEffect } from "react";
import PropTypes from "prop-types";

const InfiniteScroll = ({ children, onNextLoad, offset }) => {
    useEffect(() => {
        const handleScroll = () => {
            if ($(window).scrollTop() >= $(document).height() - $(window).height() - offset) {
                onNextLoad && onNextLoad();
            }
        };

        $(window).scroll(handleScroll);

        // Cleanup scroll event listener on unmount
        return () => {
            $(window).off("scroll", handleScroll);
        };
    }, [onNextLoad, offset]);

    return children;
};

InfiniteScroll.propTypes = {
    onNextLoad: PropTypes.func.isRequired,
    offset: PropTypes.number,
};

InfiniteScroll.defaultProps = {
    offset: 60,
};

export default InfiniteScroll;
